import React, { useState, useEffect } from 'react';
import './TestimonialsPage.css';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import DashboardLayout from '../Dashboard/layout';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Form, Image } from 'react-bootstrap';
import countryList from './countriescities.json';

const EditTestimonialsPage = () => {
  const { testimonialId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    age: '',
    country: '',
    bio: '',
    image: null,
  });

  const [imagePreview, setImagePreview] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [countries] = useState(countryList);

  useEffect(() => {
    const fetchTestimonialData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/admin/testimonials/${testimonialId}`
        );
        const data = response.data.testimonial;
        console.log("Fetched Testimonial Data:", data);

        setFormData({
          name: data.name,
          age: data.age,
          country: data.country, // Matches the field correctly here
          bio: data.bio,
          image: null, // No need to set the image here
        });

        if (data.image) {
          setImagePreview(`${data.image}`);
        } else {
          setImagePreview('');
        }

        setLoading(false);
      } catch (error) {
        console.error('Error fetching testimonial data:', error);
        setError('Failed to fetch testimonial data.');
        setLoading(false);
      }
    };

    if (testimonialId) {
      fetchTestimonialData();
    }
  }, [testimonialId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file,
      }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate country selection
    if (!formData.country) {
      setError('Please select a country.');
      return;
    }

    setError(null); // Clear previous errors
    try {
      setLoading(true);
      const formDataToSubmit = new FormData();
      formDataToSubmit.append('name', formData.name);
      formDataToSubmit.append('age', formData.age);
      formDataToSubmit.append('country', formData.country);
      formDataToSubmit.append('bio', formData.bio);

      if (formData.image) {
        formDataToSubmit.append('image', formData.image);
      }

      await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/admin/testimonials/${testimonialId}`,
        formDataToSubmit
      );

      setLoading(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Testimonial updated successfully!',
      });
      setFormData({
        name: '',
        age: '',
        country: '',
        bio: '',
        image: null,
      });
      setImagePreview(''); // Reset image preview
      navigate('/testimonials');
    } catch (error) {
      console.error('Error updating testimonial:', error);
      setError('Failed to update testimonial.');
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update testimonial. Please try again later.',
      });
    }
  };

  return (
    <DashboardLayout>
      <section className="MainDivSec">
        <Headings headspan="Edit" hedtext=" Testimonial" />
        <div className="AdduserFormDiv">
          {error && <p className="error-message">{error}</p>}
          {loading ? (
            <p className="Loadingpara">Loading...</p>
          ) : (
            <Form onSubmit={handleSubmit}>
              <div className="FormGroupDiv">
                <label htmlFor="name">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter Testimonial name"
                  required
                />
              </div>

              <div className="FormGroupDiv">
                <label htmlFor="age">Age:</label>
                <input
                  type="number"
                  id="age"
                  name="age"
                  value={formData.age}
                  onChange={handleInputChange}
                  placeholder="Enter age"
                  required
                />
              </div>

              <div className="FormGroupDiv">
                <label htmlFor="country">Country:</label>
                <select
                  id="country" // Fixed the name here to 'country'
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select country</option>
                  {countries.map((country, index) => (
                    <option key={index} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
                {error && formData.country === '' && (
                  <p className="error-message">{error}</p>
                )}
              </div>

              <div className="FormGroupDiv">
                <label htmlFor="bio">Bio:</label>
                <textarea
                  id="bio"
                  name="bio"
                  value={formData.bio}
                  onChange={handleInputChange}
                  placeholder="Enter bio"
                  required
                />
              </div>

              <div className="FormGroupDiv">
                <label htmlFor="image">Upload Image:</label>
                <input
                  type="file"
                  id="image"
                  name="image"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </div>

              {imagePreview && (
                <div className="TestiImgpreview">
                  <p>Image Preview:</p>
                  {/* <Image  src={imagePreview}  width={150}  height={150} alt="Picture of the Testimonials" /> */}
                  <Image src={imagePreview}  width={150}  height={150} alt="Picture of the Testimonials" />
                </div>
              )}

              <div className="SubMit">
                <button type="submit" disabled={loading}>
                  {loading ? 'Updating...' : 'Update Testimonial'}
                </button>
              </div>
            </Form>
          )}
        </div>
      </section>
    </DashboardLayout>
  );
};

export default EditTestimonialsPage;
